import { render } from "./FooterPage.vue?vue&type=template&id=2cfc0cc8"
import script from "./FooterPage.vue?vue&type=script&lang=js"
export * from "./FooterPage.vue?vue&type=script&lang=js"

import "./FooterPage.vue?vue&type=style&index=0&id=2cfc0cc8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__